import type { Location, LocationState } from 'history';
import { createContext, useContext, useEffect, useState } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useLocation as useLocationOriginal } from 'react-router';
import history, { LocationStateWithBackground } from '../../routing/history';

const backgroundRouteContext = createContext(true);

export const BackgroundRouteContextProvider = backgroundRouteContext.Provider;

const useLocation = <S = LocationState>() => {
    const location = useLocationOriginal<{ backgroundLocation?: Location<S> } | undefined>();
    const isBackground = useContext(backgroundRouteContext);
    const backgroundLocation = location.state?.backgroundLocation;
    return (isBackground && backgroundLocation) || (location as Location<S>);
};

export const useModalRouteDepth = () => {
    const location = useLocationOriginal<LocationStateWithBackground>();
    return location.state?.modalRouteDepth;
};

/**
 * @deprecated Only use if you must, e.g. when react is wrapped in angular
 */
export const useLocationOutsideRouterContext = () => {
    if (!history) {
        throw new Error('useLocation must not be used outside the SPA');
    }

    const [location, setLocation] = useState(history.location);

    useEffect(() => {
        if (history) {
            return history.listen(newLocation => {
                setLocation(newLocation);
            });
        }
    }, []);

    return location;
};

export default useLocation;
